import utils from '@eitje/utils'
import {getWeight, toString} from '../text/helpers'
import '../text/styles/index.less'

export const TooltipText = ({t = {}, text}) => {
	const textValue = toString(_.isString(text) ? {t: text} : {children: text, t})

	if (_.isEmpty(textValue)) return null

	const className = utils.makeCns('text', 'white', getWeight({semiBold: true}), 'text-center')

	// Text uses Tooltip for truncated content, so using it here would create a dependency cycle.
	return <p className={className}>{textValue}</p>
}
